import { AsyncPipe } from '@angular/common';
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AblePurePipe } from '@casl/angular';
import { AppSubjects } from '@pflegix/authorization';
import { GlobalSearchComponent, GlobalSearchEventService } from '@pflegix/global-search';
import { IGlobalSearchModelData } from '@pflegix/types';
import { MegaMenuItem } from 'primeng/api';
import { ImageModule } from 'primeng/image';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'pfx-app-topbar',
  templateUrl: './app.topbar.component.html',
  imports: [GlobalSearchComponent, AppBreadcrumbComponent, AblePurePipe, AsyncPipe, ImageModule],
  styles: `
    :host ::ng-deep .p-overlaybadge .p-badge {
      outline-width: 0px;
    }
  `,
})
export class AppTopbarComponent {
  private readonly layoutService = inject(LayoutService);
  public readonly el = inject(ElementRef);
  private readonly router = inject(Router);
  private readonly globalSearchEventService = inject(GlobalSearchEventService);

  @ViewChild('menuButton') public menuButton!: ElementRef;

  @ViewChild('mobileMenuButton') public mobileMenuButton!: ElementRef;

  @ViewChild('searchInput') public searchInput!: ElementRef;

  protected showGlobalSearch = false;

  protected activeItem!: number;

  protected readonly appSubjects = AppSubjects;

  protected model: MegaMenuItem[] = [
    {
      label: 'UI KIT',
      items: [
        [
          {
            label: 'UI KIT 1',
            items: [
              {
                label: 'Form Layout',
                icon: 'pi pi-fw pi-id-card',
                routerLink: ['/uikit/formlayout'],
              },
              { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
              {
                label: 'Float Label',
                icon: 'pi pi-fw pi-bookmark',
                routerLink: ['/uikit/floatlabel'],
              },
              { label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button'] },
              { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
            ],
          },
        ],
        [
          {
            label: 'UI KIT 2',
            items: [
              { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
              { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
              { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
              { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
              { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
            ],
          },
        ],
        [
          {
            label: 'UI KIT 3',
            items: [
              { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
              { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
              { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
              { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
              { label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc'] },
            ],
          },
        ],
      ],
    },
    {
      label: 'UTILITIES',
      items: [
        [
          {
            label: 'UTILITIES 1',
            items: [
              { label: 'Icons', icon: 'pi pi-fw pi-prime', routerLink: ['utilities/icons'] },
              {
                label: 'PrimeFlex',
                icon: 'pi pi-fw pi-desktop',
                url: 'https://www.primefaces.org/primeflex/',
                target: '_blank',
              },
            ],
          },
        ],
      ],
    },
  ];

  protected get mobileTopbarActive(): boolean {
    return this.layoutService.state.topbarMenuActive;
  }

  protected onMenuButtonClick(): void {
    this.layoutService.onMenuToggle();
  }

  protected onRightMenuButtonClick(): void {
    this.layoutService.openRightSidebar();
  }

  protected onMobileTopbarMenuButtonClick(): void {
    this.layoutService.onTopbarMenuToggle();
  }

  protected toggleGlobalSearch(event: MouseEvent): void {
    event.stopPropagation();
    this.showGlobalSearch = !this.showGlobalSearch;
  }

  protected handleSelectedModel(modelResult: IGlobalSearchModelData): void {
    const url = this.globalSearchEventService.getUrl(modelResult);

    this.router.navigate([url]);
  }
}
